var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"dense":"","single-line":"","multiple":"","clearable":"","menu-props":{maxHeight: 370},"items":_vm.items,"rules":_vm.rules},on:{"input":_vm.emitValue},model:{value:(_vm.formValue),callback:function ($$v) {_vm.formValue=$$v},expression:"formValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }